import useGetApiReq from '@/hooks/useGetApiReq';
import { useEffect, useState } from 'react'
import SubFolder from '../subfolder/SubFolder';
import { saveDoc } from '@/utils/download';

const Folder = ({ folder, folderIdAndType, setFolderIdAndType, isDownload=false }) => {
    const { res: subFolderRes, fetchData: fetchSubFolderData, isLoading: isSubFolderLoading } = useGetApiReq();

    const [isFolderOpen, setIsFolderOpen] = useState(false);

    console.log("isfolderopen",isFolderOpen);
    
    
    const [allSubFolders, setAllSubFolders] = useState([]);
    const [updateDocs, setUpdateDocs] = useState([]);
    
    console.log("allSubFolders",allSubFolders);

    const handleFolderOpen = (type, id, name) => {
        setFolderIdAndType(() => ({ folderType: type, fId: id, folderName: name }));
        setIsFolderOpen(() => !isFolderOpen);
    }


    const getSubFolders = () => {
        fetchSubFolderData(`/client/get-subfolders-and-docs/${folderIdAndType.fId}?flag=folder`);
    }

    useEffect(() => {
        if (folderIdAndType.fId === folder?._id) {
            getSubFolders();
        }
    }, [folderIdAndType])


    useEffect(() => {
        if (subFolderRes?.status === 200 || subFolderRes?.status === 201) {
            console.log("subFolderRes", subFolderRes);
            setAllSubFolders(subFolderRes?.data?.subfolders);
            setUpdateDocs(subFolderRes?.data?.updateDocs);
        }
    }, [subFolderRes])


    const { res: docRes, fetchData: fetchDocData, isLoading: isDocLoading } = useGetApiReq();

    const getDoc = (doc) => {
        if (isDownload) {
            fetchDocData(`/client/get-doc?url=${doc}`);
        }
    }

    useEffect(() => {
        if (docRes?.status === 200 || docRes?.status === 201) {
            console.log("Document", docRes);
            saveDoc(docRes?.data?.preSignedUrl);
        }
    }, [docRes])


    return (
      <div className="w-full m-2 ">
        <div className="w-full">
          <div
            onClick={() =>
              handleFolderOpen("folder", folder?._id, folder?.name)
            }
            className={`glass-header !border-white !border-2 cursor-pointer m-2 w-full font-semibold px-3 py-[2px] border ${
              folder?._id === folderIdAndType.fId && "border-blue-500"
            }`}
          >
            📁 {folder?.name}
          </div>
          {isFolderOpen && (
            <div>
              {allSubFolders?.map((subfolder) => (
                <SubFolder
                  key={subfolder?._id}
                  setFolderIdAndType={setFolderIdAndType}
                  subfolder={subfolder}
                  folderIdAndType={folderIdAndType}
                  isDownload={isDownload}
                />
              ))}
              {updateDocs?.map((doc) => (
                <div className="w-full m-2" key={doc?._id}>
                  <div
                    onClick={() => getDoc(doc?.doc)}
                    className="glass-header !border-white !border-2 cursor-pointer w-full ml-4 text-sm py-[2px] px-3"
                  >
                    📄 {doc?.doc}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
}

export default Folder